import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
  HttpXhrBackend
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { convertDateToMaskTimezone } from '@app/shared/utils';
import { catchError, Observable, throwError } from 'rxjs';
import { ConfigService, TokenService } from 'viggo-sistemas-core-web';
import { IDashboardInfo } from '../model/dashboard.model';

@Injectable()
export class DashboardInfoService {
  http = new HttpClient(
    new HttpXhrBackend({
      build: () => new XMLHttpRequest()
    })
  );

  constructor(
    protected configService: ConfigService,
    protected tokenService: TokenService
  ) {}

  protected handleError(error: HttpErrorResponse) {
    return throwError(() => error);
  }

  private getHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    if (this.tokenService.getToken())
      headers = headers.append('token', this.tokenService.getToken().id);
    return headers;
  }

  /**
   * Filtro inicial colocando faixa de datas do primeiro dia ate o ultimo dia do mês
   * @returns
   */
  public getValuesDashboard(
    linhaProducaoId: string
  ): Observable<IDashboardInfo> {
    let url = `${this.configService.backendURL}dashboards`;
    const headers = this.getHeaders();
    var date = new Date();
    let params = new HttpParams();

    var primeiroDiaDoMes = new Date(date.getFullYear(), date.getMonth(), 1);
    const primeiroDia = convertDateToMaskTimezone(
      primeiroDiaDoMes.getFullYear() +
        '-' +
        (primeiroDiaDoMes.getMonth() + 1) +
        '-' +
        primeiroDiaDoMes.getDate()
    );
    const ultimoDia = convertDateToMaskTimezone(date);

    params = params.set('de', primeiroDia);
    params = params.set('ate', ultimoDia);
    params = params.set('linha_producao_id', linhaProducaoId);
    return this.http
      .get<IDashboardInfo>(url, { headers, params })
      .pipe(catchError(this.handleError));
  }

  /**
   * Captura o valor da faixa de datas (De - Até)
   */
  public filtrarPorDatas(
    de: string,
    ate: string,
    linhaProducaoId: string,
    preCadastroId?: string,
    modeloId?: string
  ) {
    const headers = this.getHeaders();

    let url = `${this.configService.backendURL}dashboards`;
    let params = new HttpParams();

    params = params.set('de', de);
    params = params.set('ate', ate);
    params = params.set('linha_producao_id', linhaProducaoId);
    if (preCadastroId && preCadastroId !== '')
      params = params.set('pre_cadastro_id', preCadastroId);
    if (modeloId && modeloId !== '') params = params.set('modelo_id', modeloId);

    return this.http
      .get<IDashboardInfo>(url, { headers, params })
      .pipe(catchError(this.handleError));
  }
}
